import { AppointmentDataGetter, AppointmentDisplayData } from './AppointmentDataGetter'
import { PresenceStatus } from '../constants'
import { formatMessage } from '../../../constants/strings/intl/intlHooks'
import { messages } from '../../../constants/strings/messages'
import { formatDateWithMonthName } from '../../../utils/formatters'
import dayjs from 'dayjs'
import { VisitorStatusType } from '../../../constants/types'
import { getGlobal } from 'reactn'
import { GetAvailableVisitationRaffles_listUserVisitEvents } from '../../../services/types/getAvailableVisitationRaffles'

interface VisitationToConstructionCallbackFunctions {
  onPressCancelVisitation: (id: string) => void
  onPressConfirmVisitation: (id?: string) => void
}

export class VisitationToConstructionAppointmentDataGetter extends AppointmentDataGetter {
  functions: VisitationToConstructionCallbackFunctions

  constructor(functions: VisitationToConstructionCallbackFunctions) {
    super()
    this.functions = functions
  }

  public getAppointmentDisplayData(
    appointment: GetAvailableVisitationRaffles_listUserVisitEvents
  ): AppointmentDisplayData {
    const { address, name } = this.getConstructionInfo(appointment) || { address: '', name: '' }

    return {
      bottomMessage: this.getBottomMessage(appointment),
      cancelAction: () => this.functions.onPressCancelVisitation(appointment?.visitEvent.id),
      confirmAction: () => this.functions.onPressConfirmVisitation(appointment?.visitEvent.id),
      constructionName: name,
      eventDate: formatDateWithMonthName(appointment?.visitEvent.date),
      eventTime: dayjs(appointment?.visitEvent.date)
        .hour()
        .toString(),
      eventAddress: address,
      presenceStatus:
        appointment?.subscription.status === VisitorStatusType.confirmed
          ? PresenceStatus.CONFIRMED
          : PresenceStatus.NONE,
      subtitle: formatMessage(messages.appointments_visitationToConstructionSubtitle),
      title: formatMessage(messages.appointments_visitationToConstructionTitleLabel),
    }
  }

  private getBottomMessage(appointment: GetAvailableVisitationRaffles_listUserVisitEvents): string {
    return appointment?.subscription.status === VisitorStatusType.confirmed
      ? formatMessage(messages.appointments_visitationToConstructionConfirmedSuccessfully)
      : `${formatMessage(
          messages.appointments_visitationToConstructionConfirmationLimitDate
        )} ${formatDateWithMonthName(appointment?.visitEvent.closeSubscribeListDate)}`
  }

  private getConstructionInfo(appointment: GetAvailableVisitationRaffles_listUserVisitEvents) {
    const userSaleContracts = getGlobal().userSaleContracts

    return userSaleContracts?.find(item => item?.construction.id === appointment?.visitEvent?.construction.id)
      ?.construction
  }
}
